import $ from "jquery";
import BrowserDetect from 'utils/browserdetect.js';

export default function NumberArrowKeySupport() {
}

function browserNeedsFixing(browserDetect) {
  var ie = browserDetect.browser === "Explorer";
  var ff = browserDetect.browser === "Firefox" && browserDetect.version <= 28;
  return ie || ff;
}

NumberArrowKeySupport.prototype.init = function () {
  var browserDetect = new BrowserDetect();
  browserDetect.init();

  if (browserNeedsFixing(browserDetect)) {
    $(':input[name="amount"]').keydown(function (event) {
      var value = parseInt($(this).val());
      switch (event.which) {
        case 38: // up
          $(this).val(value + 1);
          $(this).trigger("change");
          break;

        case 40: // down
          if (value > 1) {
            $(this).val(value - 1);
            $(this).trigger("change");
          }
          break;

        default:
          return;
      }

      event.preventDefault();
    });
  }
}

